module.exports = __webpack_public_path__ + "static/cnn-b3d422efe08cc14e61d75f1eafa0b4e6.png";